<div class="d-f fd-c jc-sb {{ size }} ctn">
	<header class="d-f jc-sb ai-c p-xxxs fs-sm fw-bold">
		<h6>{{ modalTitle }}</h6>
		<button
			mat-icon-button
			aria-label="close modal"
			(click)="modalClose.emit()"
		>
			<mat-icon svgIcon="sanus-closeb"></mat-icon>
		</button>
	</header>
	<div class="pl-xxxs pr-xxxs h-100 oy-a">
		<ng-content></ng-content>
	</div>
	<footer class="d-f jc-fe ai-c p-nano pr-xxxs">
		<button
			mat-flat-button
			color="primary"
			[disabled]="btnDisabled"
			(click)="modalAction.emit()"
		>
			{{ btnLabel }}
		</button>
	</footer>
</div>
